import { InputHTMLAttributes } from 'react';
import InputMask from 'react-input-mask-next';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  size?: number;
}

export const InputDateMask = ({ name, size, ...rest }: InputProps) => {
  return (
    <div>
      <InputMask
        mask="99/99/9999"
        name={name}
        style={{ width: size }}
        {...rest}
      />
    </div>
  );
};
